import axios from 'axios';

export enum ImportState {
  Active = 1,
  Waiting = 2,
  Finished = 3,
  Error = 4,
}

export interface ImportJobDTO {
  id: number;
  fileId: string;
  filename: string;
  importType: string;
  created: Date;
  state: ImportState;
  status: string;
  principalName: string;
}

class ImportApiClass {
  async upload(file: any) {
    try {
      const data = new FormData();
      for (const key in file) {
        data.append('file', file[key]);
      }
      await axios.post('/api/import', data);
    } catch (error) {
      console.log('there was some error sending file');
    }
  }

  async analyze(file: any) {
    try {
      const data = new FormData();
      for (const key in file) {
        data.append('file', file[key]);
      }
      const response = await axios.post('/api/import/analyze', data);
      return response.data;
    } catch (error: any) {
      console.error('there was some error sending file');
      return [
        {
          fileName: '',
          importType: '',
          submission: '',
          fileIdentity: '',
          dataRows: '',
          error: error.message + ' ' + JSON.stringify(error.data),
        },
      ];
    }
  }

  async getAll(): Promise<ImportJobDTO> {
    const jobs = await axios.get('/api/import/importjobs');
    return jobs.data;
  }

  async deleteById(id: number) {
    await axios.delete('/api/import/' + id);
  }
}

export const ImportApi = new ImportApiClass();
